import * as React from "react"
import { Link } from "gatsby"
import { getLocalizedPathFromContext } from "./getLocalizedRoute"
import { usePageContext } from "./PageContext"

export const LocalizedLink = (props: { to: string } & any) => {
  const context = usePageContext()
  return <Link {...props} to={getLocalizedPathFromContext(props.to, context)} />
}
